export default "__VITE_ASSET__a1d575f9__"